import React from "react"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"
import ContactBar from "../../ContactBars/ContactBar"
import PhoneIcon from "../../../images/iconmonstr-phone-6.svg"
import FaxIcon from "../../../images/format_list_bulleted-24px.svg"
import MapIcon from "../../../images/placeholder-on-map-paper-in-perspective-svgrepo-com.svg"
import ArrowIcon from "../../../images/iconmonstr-arrow-20.svg"
import Button from "../../Button/Button"

const HomeContactInfoStyles = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  .ContactBar--lg,
  .HomeContact-button {
    margin: 0 0 25px;
    padding: 0;
    width: auto;
    @media screen and (min-width: 1500px) {
      width: 100%;
      margin: 0 25px 25px 0;
    }
  }
  .HomeContact-button {
    svg {
      transform: rotate(90deg);
    }
  }
  @media screen and (min-width: 650px) {
    width: 50%;
  }
  @media screen and (min-width: 1500px) {
    width: 335px;
  }
`

const HomeContactInfo = ({ info }: any) => {
  const { streetAddress, city, state, zip, phone, fax } = info
  return (
    <HomeContactInfoStyles>
      <ContactBar icon={<PhoneIcon />}>{phone}</ContactBar>
      {fax && <ContactBar icon={<FaxIcon />}>{fax}</ContactBar>}
      <ContactBar icon={<MapIcon />} smallText>
        {streetAddress}
        <br />
        {city} {state}, {zip}
      </ContactBar>
      <Button
        side="lt"
        size="lg"
        icon={<ArrowIcon />}
        className="HomeContact-button"
        element="a"
        href="#HomePage-contactForm"
      >
        Contact Form
      </Button>
    </HomeContactInfoStyles>
  )
}

export default HomeContactInfo
